/*
 * PAWS & PEARLS — THE MUSE · RIGHTWARD LOOKOUT TURN V1
 * 27 October 2026 · MAGICAL MUSE WORLD unpublished test theme only.
 * Independent reversible visual accessory for the EXISTING V18 balloon.
 * Never replaces the original picture src, V18 animation, its WAAPI motion,
 * Camera / Journey V1.1, companion prelude, music, pearls or sky geometry.
 *
 * Uses the archived 27 Oct turning poses, with the approved 25 Oct #10 rear view.
 * All assets are full-sized RGBA equivalents of 1254 × 1254 PNG originals.
 * The first pose displayed is always the actual V18 picture (not a substitute).
 */
(function () {
  'use strict';
  var NS = 'ppMuseBalloonTurnLookoutV1';
  var cfgId = 'pp-muse-balloon-turn-lookout-assets';
  var stageId = 'pp-muse-balloon-stage';
  var FLIGHT_MS = 39000;
  var SUMMIT_MS = 16000;
  var RETURN_MS = 24000;
  var PAUSE_BEFORE_TURN_MS = 1000;
  var FRAME_SPACING_MS = 1050;
  var FADE_MS = 550;
  var LOOP_MS = 85;
  var controllers = new WeakMap();

  function findMotion(button) {
    if (!button || !button.getAnimations) return null;
    try {
      var a = button.getAnimations();
      for (var i = 0; i < a.length; i++) {
        var effect = a[i].effect;
        if (!effect || !effect.getTiming) continue;
        if (Math.abs(Number(effect.getTiming().duration) - FLIGHT_MS) < 1 &&
            a[i].playState !== 'idle' && a[i].playState !== 'finished') return a[i];
      }
    } catch (_) { /* If motion identification fails, V18 remains untouched. */ }
    return null;
  }

  function init() {
    var root = document.documentElement;
    if (!root.classList.contains('pp-muse-secret-sky-page')) return;
    var stage = document.getElementById(stageId);
    var assets = document.getElementById(cfgId);
    if (!stage || !assets || controllers.has(stage)) return;
    var button = stage.querySelector('.pp-balloon');
    var original = button && button.querySelector('img');
    if (!button || !original) return;
    var urls = [assets.dataset.turn1, assets.dataset.turn2,
                assets.dataset.turn3, assets.dataset.rear];
    if (urls.some(function (s) { return !s || !/^(https?:\/\/|\/)/.test(s); })) {
      console.warn('[P&P Muse lookout] Missing approved frame URL; effect disabled.');
      return;
    }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var loaded = new Array(4).fill(false);
    urls.forEach(function (url, i) {
      var img = new Image();
      img.onload = function () { loaded[i] = true; };
      img.onerror = function () { console.warn('[P&P Muse lookout] Frame unavailable:', i + 1); };
      img.src = url;
      if (img.complete && img.naturalWidth > 0) loaded[i] = true;
    });

    var current = null;
    var interval = 0;
    var timers = [];
    var pane = null;
    var faces = null;
    var hiddenOpacity = null;
    var didTurn = false;
    var didReturn = false;
    var turnAt = null;
    var controllerAlive = true;
    var steps = 0;

    function later(fn, ms) {
      var id = setTimeout(fn, ms);
      timers.push(id);
    }
    function clearAllTimers() {
      timers.forEach(clearTimeout);
      timers.length = 0;
    }
    function stop() {
      if (interval) { clearInterval(interval); interval = 0; }
      clearAllTimers();
      if (pane) { pane.remove(); pane = null; faces = null; }
      // Restore ORIGINAL inline opacity, including its priority.
      if (hiddenOpacity !== null) {
        original.style.removeProperty('opacity');
        if (hiddenOpacity.value) original.style.setProperty('opacity', hiddenOpacity.value, hiddenOpacity.priority);
        hiddenOpacity = null;
      }
      current = null;
      didTurn = false;
      didReturn = false;
      turnAt = null;
    }

    function buildPane() {
      if (pane || !current || !original.isConnected ||
          !button.classList.contains('pp-muse-flight-overlay')) return false;
      if (!loaded.every(Boolean)) return false;
      pane = document.createElement('span');
      pane.className = 'pp-muse-balloon-turn-lookout-layer';
      pane.setAttribute('aria-hidden', 'true');
      pane.style.cssText = 'position:absolute!important;left:0!important;top:0!important;' +
        'width:100%!important;height:100%!important;pointer-events:none!important;' +
        'display:block!important;z-index:2!important;' +
        'animation:pp-muse-hover 4s ease-in-out infinite!important;';
      // Match the original picture's bobbing phase, avoiding a visual jump.
      try {
        var animations = original.getAnimations ? original.getAnimations() : [];
        for (var j = 0; j < animations.length; j++) {
          if (animations[j].animationName === 'pp-muse-hover' && animations[j].currentTime !== null) {
            pane.style.setProperty('animation-delay', (-Number(animations[j].currentTime) % 4000) + 'ms', 'important');
            break;
          }
        }
      } catch (_) { /* Consistent placement matters more than phase matching. */ }
      faces = [];
      for (var i = 0; i < 2; i++) {
        var img = document.createElement('img');
        img.alt = '';
        img.draggable = false;
        img.setAttribute('aria-hidden', 'true');
        img.style.cssText = 'position:absolute!important;left:0!important;top:0!important;' +
          'width:100%!important;height:auto!important;max-width:none!important;' +
          'display:block!important;object-fit:contain!important;pointer-events:none!important;' +
          'animation:none!important;transform:none!important;' +
          'transition:opacity ' + FADE_MS + 'ms ease-in-out!important;' +
          'opacity:' + (i === 0 ? 1 : 0) + '!important;';
        pane.appendChild(img);
        faces.push(img);
      }
      faces[0].src = original.currentSrc || original.src;
      button.appendChild(pane);
      hiddenOpacity = { value: original.style.getPropertyValue('opacity'),
                        priority: original.style.getPropertyPriority('opacity') };
      original.style.setProperty('opacity', '0', 'important');
      return true;
    }

    var shown = 0;
    var frontImage = 0;
    var sequence = null;
    
function crossTo(url) {
  if (!pane || !current || !faces) return;

  var next = 1 - frontImage;
  var incoming = faces[next];
  var outgoing = faces[frontImage];
  var change = ++steps;

  // Keep the currently displayed balloon fully visible.
  outgoing.style.setProperty('opacity', '1', 'important');
  outgoing.style.setProperty('z-index', '1', 'important');

  // Prepare the incoming image ABOVE it, but invisible.
  incoming.style.setProperty('transition', 'none', 'important');
  incoming.style.setProperty('opacity', '0', 'important');
  incoming.style.setProperty('z-index', '2', 'important');
  incoming.src = url;

  function reveal() {
    if (!pane || !faces || !current ||
        change !== steps || !incoming.isConnected) return;

    incoming.getBoundingClientRect();

    requestAnimationFrame(function () {
      if (!pane || !faces || !current ||
          change !== steps || !incoming.isConnected) return;

      incoming.style.setProperty(
        'transition',
        'opacity ' + FADE_MS + 'ms ease-in-out',
        'important'
      );

      incoming.style.setProperty('opacity', '1', 'important');
      frontImage = next;

      // Hide the old frame ONLY after the new one
      // has become fully visible.
      later(function () {
        if (!pane || !faces || !current ||
            change !== steps) return;

        outgoing.style.setProperty('opacity', '0', 'important');
      }, FADE_MS + 40);
    });
  }

  // Wait until Safari has decoded the incoming picture.
  if (typeof incoming.decode === 'function') {
    incoming.decode().then(reveal, function () {
      if (incoming.complete && incoming.naturalWidth > 0) {
        reveal();
      } else {
        console.warn(
          '[P&P Muse lookout] Frame not ready; retaining previous image.'
        );
      }
    });
  } else if (incoming.complete && incoming.naturalWidth > 0) {
    reveal();
  } else {
    incoming.addEventListener('load', reveal, { once: true });
  }
}

    function turnOut() {
      if (!current || didTurn || !button.classList.contains('pp-muse-flight-overlay')) return;
      if (!buildPane()) return;
      didTurn = true;
      frontImage = 0;
      sequence = urls.slice();
      sequence.forEach(function (url, i) {
        later(function () { crossTo(url); }, i * FRAME_SPACING_MS);
      });
    }
    function turnHome() {
      if (!pane || !didTurn || didReturn || !current) return;
      didReturn = true;
      var seq = [urls[2], urls[1], urls[0], original.currentSrc || original.src];
      seq.forEach(function (url, i) {
        later(function () { crossTo(url); }, i * FRAME_SPACING_MS);
      });
      later(function () {
        // We are showing the original image again. Remove our temporary layer.
        if (current) {
          if (pane) { pane.remove(); pane = null; faces = null; }
          if (hiddenOpacity !== null) {
            original.style.removeProperty('opacity');
            if (hiddenOpacity.value) original.style.setProperty('opacity', hiddenOpacity.value, hiddenOpacity.priority);
            hiddenOpacity = null;
          }
        }
      }, 3 * FRAME_SPACING_MS + FADE_MS + 60);
    }
    function tick() {
      if (!current || !button.isConnected || !stage.isConnected ||
          !button.classList.contains('pp-muse-flight-overlay') ||
          current.playState === 'finished' || current.playState === 'idle') {
        stop(); return;
      }
      var ms = Number(current.currentTime);
      if (!isFinite(ms)) return;
      if (!didTurn && ms >= SUMMIT_MS - 8 && ms < RETURN_MS - 100) {
        if (turnAt === null) turnAt = performance.now();
        if (performance.now() - turnAt >= PAUSE_BEFORE_TURN_MS) turnOut();
      }
      if (didTurn && !didReturn && ms >= RETURN_MS + 60) turnHome();
      if (ms >= FLIGHT_MS - 100) stop();
    }
    function begin(event) {
      if (!controllerAlive || current || (reduced && reduced.matches)) return;
      var clicked = event.target && event.target.closest &&
        event.target.closest('#pp-muse-balloon-stage .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
      if (clicked !== button || !button.classList.contains('pp-muse-flight-overlay')) return;
      var flight = findMotion(button);
      if (!flight) return;
      current = flight;
      interval = setInterval(tick, LOOP_MS);
    }
    function sectionUnload(event) {
      if (event.target && (event.target.contains(stage) ||
          event.target.contains(button))) {
        stop();
        controllerAlive = false;
        document.removeEventListener('click', begin);
        document.removeEventListener('shopify:section:unload', sectionUnload);
        controllers.delete(stage);
      }
    }
    document.addEventListener('click', begin);
    document.addEventListener('shopify:section:unload', sectionUnload);
    controllers.set(stage, true);
    window[NS] = {version:'1.0', stage: stageId, looksOutAtSummit:true,
      getStatus:function () { return {active:!!current, turned:didTurn, returned:didReturn,
                                sourceOriginalUnchanged: original.getAttribute('src'),
                                displayedViewChanges: steps}; }};
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else init();
  document.addEventListener('shopify:section:load', init);
})();
